import React from 'react';
import { SxStyle } from '../../../../types';
import Popover, { PopoverOrigin } from '@mui/material/Popover';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getTeamName } from '../helpers';
import { TeamMinimized } from '../types';

const styles: SxStyle = {
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: 'transparent',
    paddingBottom: '10px',
    paddingLeft: '10px',
  },
  innerContainer: {
    backgroundColor: '#616161',
    borderRadius: 4,
    padding: 8,
  },
  text: {
    fontWeight: 'bold',
    color: 'white',
  },
  arrowBottom: {
    width: '10px',
    height: '10px',
    position: 'absolute',
    bottom: '5px',
    backgroundColor: '#616161',
    transform: 'rotate(45deg)',
  },
  arrowRight: {
    width: '10px',
    height: '10px',
    position: 'absolute',
    left: '2px',
    top: '50%',
    transform: 'rotate(45deg) translateY(-50%)',
    backgroundColor: '#616161',
  },
};

interface Props {
  appTeams: TeamMinimized[];
  teamAbbrvs: string[];
  anchorEl: HTMLElement | null;
  onPopoverClose: () => void;
}

const anchorOrigin: Record<'top' | 'left', PopoverOrigin> = {
  top: {
    vertical: 'top',
    horizontal: 'center',
  },
  left: {
    vertical: 'center',
    horizontal: 'right',
  },
};

const transformOrigin: Record<'top' | 'left', PopoverOrigin> = {
  top: {
    vertical: 'bottom',
    horizontal: 'center',
  },
  left: {
    vertical: 'center',
    horizontal: 'left',
  },
};

const TeamsPopover = ({ appTeams, teamAbbrvs, anchorEl, onPopoverClose }: Props) => {
  const compressed = teamAbbrvs.length > 8;
  const anchorPos = compressed ? 'left' : 'top';
  const abbrvs = compressed ? [...teamAbbrvs.slice(0, 8), '...'] : teamAbbrvs;

  return (
    <Popover
      id="mouse-over-popover"
      sx={{
        pointerEvents: 'none',
      }}
      open={!!anchorEl}
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin[anchorPos]}
      transformOrigin={transformOrigin[anchorPos]}
      onClose={onPopoverClose}
      disableRestoreFocus
      PaperProps={{
        elevation: 0,
        style: { backgroundColor: 'transparent' },
        variant: 'elevation',
        square: true,
      }}
    >
      <Box sx={styles.container}>
        <Box sx={styles.innerContainer}>
          {abbrvs.map((abbrv, index) => (
            <Typography variant="body2" sx={styles.text} key={index}>
              {getTeamName(appTeams, abbrv)}
            </Typography>
          ))}
        </Box>
        <Box sx={compressed ? styles.arrowRight : styles.arrowBottom}></Box>
      </Box>
    </Popover>
  );
};

export default TeamsPopover;
